import { useLocation, useNavigate } from 'react-router';
import React from 'react';

// This code has been created in order for use-query-params to work with React Router v7
// It has been taken from https://github.com/pbeshai/use-query-params/issues/295
interface CustomReactRouter7AdapterProps {
  children: (props: {
    location: ReturnType<typeof useLocation>;
    push: (location) => void;
    replace: (location) => void;
  }) => React.ReactElement<string>;
}

const CustomReactRouter7Adapter = ({ children }: CustomReactRouter7AdapterProps) => {
  const navigate = useNavigate();

  return children({
    location: useLocation(),
    push: (location) => navigate({ search: location.search }, { state: location.state }),
    replace: (location) =>
      navigate({ search: location.search }, { replace: true, state: location.state }),
  });
};

export default CustomReactRouter7Adapter;
